<template>
  <div class="emoji-picker-input">
    <el-input
      :autosize="{ minRows: 2, maxRows: 4 }"
      v-model="form[type]"
      type="textarea"
      @keyup.native="handleInputKeyup"
      @click.native="handleInputClick"
    />
    <emoji-picker
      @select="handleEmojiSelect"
    />
  </div>
</template>

<script lang="ts">
import { createComponent, ref } from '@vue/composition-api'

import EmojiPicker from './EmojiPicker.vue'

const InputWithEmojiPicker = createComponent({
  components: {
    EmojiPicker,
  },
  props: {
    form: {
      type: Object,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const selectionPosition = ref(0)
    const handleCaretPositionUpdate = ({ target: { selectionStart } }) => {
      selectionPosition.value = selectionStart
    }

    const handleEmojiSelect = (emoji) => {
      const text = props.form[props.type]
      const front = text.slice(0, selectionPosition.value)
      const back = text.slice(selectionPosition.value)
      props.form[props.type] = `${front}${emoji}${back}`

      // update position to after emotion
      selectionPosition.value += 2
    }
    const handleInputKeyup = (e) => {
      handleCaretPositionUpdate(e)
    }
    const handleInputClick = (e) => {
      handleCaretPositionUpdate(e)
    }

    return {
      // data
      selectionPosition,

      // handlers
      handleEmojiSelect,
      handleInputKeyup,
      handleInputClick,
    }
  },
})

export default InputWithEmojiPicker
</script>

<style lang="scss" scoped>
.emoji-picker {
  position: absolute;
  top: 50%;
  right: 24px;
  margin: auto;
  transform: translateY(-50%);
}

// ::v-deep {
//   textarea {
//     font-family: Segoe UI Emoji;
//   }
// }
</style>
